import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../../shared/base-api-template-service.model';
import { Core2Config } from '../../../shared/core2Config';
import { JobAttachmentContainerModel } from '../../../../../../../models/aggregates/erp/delivery/job';
import { ApiVisa } from '../../../shared';
import { Observable } from 'rxjs';
import { Pagination, PagingResponseModel, BasicApiResponseModel } from './../../../shared';

@Injectable({
  providedIn: 'root'
})
export class JobAttachmentService extends BaseApiTemplateService<JobAttachmentContainerModel> {
  readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/job-attachments/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/job-attachments/' + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/job-attachments/' + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/job-attachments/' + BaseApiTemplateService.LOGIN_ENTITY_EP;
    this.httpClient = http;
  }

  createJobAttachment(formData: FormData, visa: ApiVisa) {
    let url = this.apiUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.post(url, formData, this.getHttpHeader(visa));
  }

  getFile(guid, visa: ApiVisa): Observable<Blob> {
    let url = this.apiUrl + '/file/' + guid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/file/' + guid;
    }
    return this.httpClient.get<Blob>(url, this.getHttpHeaderBlob(visa));
  }

  public getByGuidLoginEP(
    guid: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path_login_url && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path_login_url;
    }
    return this.httpClient.get<BasicApiResponseModel<any>>(
      this.apiUrl + '/' + guid,
      this.getHttpHeader(visa)
    );
  }

  public getByCriteria(
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Observable<PagingResponseModel<any>> {
    // console.log('get by criteria bsae-api');
    if (this.endpoint_path_login_url && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path_login_url;
    }
    const UrlByCriteria =
      this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<any>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }
  
  public getByCriteriaBackoffice(
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Observable<PagingResponseModel<any>> {
    // console.log('get by criteria bsae-api');
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<any>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  getFileLoginEP(guid, visa: ApiVisa): Observable<Blob> {
    let url = this.apiUrl + '/file/' + guid;
    if (this.endpoint_path_login_url && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path_login_url + '/file/' + guid;
    }
    return this.httpClient.get<Blob>(url, this.getHttpHeaderBlob(visa));
  }
}
